<template>
  <!-- THUMB -->
<div
  class="relative w-full h-50 overflow-hidden bg-black"
  :class="detail?.is_vip ? 'rounded-none rounded-t-md' : 'rounded-t-md'"
>
  <template v-if="detail?.thumbnail">
    <img
  :src="detail.thumbnail"
  class="absolute inset-0 m-auto w-[100%] h-[100%] object-fill z-0"
  alt="media_img"
  loading="lazy"
  decoding="async"
/>

    <div
      class="absolute inset-0 bg-[rgba(0,0,0,0.74)] z-10"
      :class="detail?.is_vip ? 'rounded-none rounded-t-md' : 'rounded-t-md'"
    ></div>

    <IconPlay class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-20" />
  </template>

  <div
    v-else
    class="absolute inset-0 flex items-center justify-center text-white/60 text-sm"
    :class="detail?.is_vip ? 'rounded-none rounded-t-md' : 'rounded-t-md'"
  >
    No thumbnail
  </div>
</div>
</template>

<script>
import IconPlay from '@icons/IconPlay.vue'
import IconShare from '@icons/IconShare.vue'
import IconEye from '@icons/IconEye.vue'
import { formatDate } from '@/helpers'
import { ref } from 'vue'
import { useClipboard } from '@vueuse/core'
import VueStarRating from 'vue-star-rating'
import { LINK_TYPE } from '@/constants'

export default {
  name: "MediaCard",
  props: {
    detail: {
      type: Object,
      required: true
    }
  },
  components: {
    IconPlay,
    IconEye,
    IconShare,
    VueStarRating
  },
  data() {
    return {
      linkType: LINK_TYPE
    }
  },
  setup() {
    const source = ref(window.location.href)
    const { text, copy, copied, isSupported } = useClipboard({ source })
    return { text, copy, copied, isSupported }
  },
  methods: {
    formatDate
  },
  computed: {
    getSubcriptionType() {
      switch (this.detail.subscription) {
        case 'Gold':
          return { color: 'bg-[#FABB18] text-black', name: 'Gold' }
        case 'Silver':
          return { color: 'bg-[#C0C0C0] text-black', name: 'Silver' }
        case 'Bronze':
          return { color: 'bg-[#AE7145] text-white', name: 'Bronze' }
        default:
          break;
      }
    }
  }
}
</script>

<style scoped></style>